import { getCookieByName } from '../utils/functions';

export function useMobileTableLayout() {
  const isNewMobileLayout = getCookieByName('new-mobile-layout', true);

  if (isNewMobileLayout) {
    return true;
  }

  return false;
}
